import { useMutation } from "@tanstack/react-query";
import {
  createSubsegmentAPI,
  deleteSubsegmentAPI,
  updateSubsegmentAPI,
} from "./subsegment.api";
import { handleNetworkError } from "@repo/ui/libs";

const useAddSubsegmentMutation = () => {
  return useMutation({
    mutationFn: createSubsegmentAPI,
    onError: handleNetworkError,
  });
};

const useUpdateSubsegmentMutation = () => {
  return useMutation({
    mutationFn: updateSubsegmentAPI,
    onError: handleNetworkError,
  });
};

const useDeleteSubsegmentMutation = () => {
  return useMutation({
    mutationFn: deleteSubsegmentAPI,
    onError: handleNetworkError,
  });
};

export {
  useAddSubsegmentMutation,
  useUpdateSubsegmentMutation,
  useDeleteSubsegmentMutation,
};
